import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { IRedditComment } from '../../Models/IRedditComment';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';
import { RedditService } from '../../Services/reddit.service';


@Component({
  selector: 'app-reddit-comments',
  templateUrl: './reddit-comments.component.html',
  styleUrl: './reddit-comments.component.scss'
})
export class RedditCommentsComponent  implements OnInit {
  @Input() submissionId?: number;
  comments: Array<IRedditComment> = [];
  isLoadingComments = false;
  commentCount: number = 0;
  errorComments: string = ''

  error: string = '';

  constructor(
    private redditService: RedditService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.submissionId)
      this.loadComments();
    else
      this.error = 'No submission ID provided';
  }



  loadComments(): void {
    this.isLoadingComments = true;
    this.errorComments = '';
    
    this.redditService.getSubmissionComments(this.submissionId as number)
      .pipe(
        finalize(() => {
          this.isLoadingComments = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response) => {
          if (response) {
            this.comments = Array.isArray(response) ? response : [response];
            this.commentCount = this.comments.length;
          } else {
            this.errorComments = 'No comments found or invalid response format';
            console.warn('No comments data in response:', response);
          }
        },
        error: (error) => {
          this.errorComments = 'Failed to load comments. Please try again.';
          console.error('Error loading comments:', error);
        }
      });
  }

  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }

 
 getInitials(fullName: string): string {
   return HelperFunctions.getInitials(fullName);
 }
}